let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1xv02")).then(() => parcelRequire('3WEzz'));